import React from "react";
import BannerHero from "@/components/bannerHero";
import LearningLayout from "@/components/layout/LearningLayout";
import Image from "next/image";


const AdventistMaterials = () => {
    return (
        <>
            <BannerHero
                title="Adventist Materials"
                bgImage="/images/about-bg.png"
                className="about"
            />
            <LearningLayout>
                <div className="text-center">
                    <h2 className="text-uppercase mb-4">Adventist Materials</h2>
                    <div className="d-flex justify-content-center">
                        <Image
                            src="/images/under_progress.png"
                            alt="Under Construction"
                            width={500}
                            height={500}
                            className="img-fluid"
                        />
                    </div>
                    <p className="mt-4 text-muted">This page is currently under construction. Please check back soon!</p>
                </div>
            </LearningLayout>
        </>
    );
};

export default AdventistMaterials;
